export default function BottlePlaceholder({ size }) {
  return (
    <div className="mc-placeholder" data-testid="card-photo-placeholder">
      <svg viewBox="0 0 240 520" className="mc-placeholder-svg" aria-hidden="true">
        <defs>
          <linearGradient id="silverBody" x1="0" x2="1">
            <stop offset="0" stopColor="#c9ced6" />
            <stop offset="0.35" stopColor="#f7f8fa" />
            <stop offset="0.6" stopColor="#dfe3e8" />
            <stop offset="1" stopColor="#aeb5bf" />
          </linearGradient>
          <linearGradient id="silverCap" x1="0" x2="1">
            <stop offset="0" stopColor="#8f97a3" />
            <stop offset="0.45" stopColor="#e9ecf0" />
            <stop offset="1" stopColor="#7d8591" />
          </linearGradient>
        </defs>
        <rect x="78" y="10" width="84" height="92" rx="10" fill="url(#silverCap)" />
        <rect x="92" y="100" width="56" height="26" fill="url(#silverCap)" opacity="0.8" />
        <path d="M60 140 Q60 126 74 126 H166 Q180 126 180 140 V490 Q180 510 160 510 H80 Q60 510 60 490 Z" fill="url(#silverBody)" stroke="#b8bec7" strokeWidth="1.5" />
        <line x1="84" y1="300" x2="156" y2="300" stroke="#9aa2ad" strokeWidth="1" />
        <text x="120" y="330" textAnchor="middle" fontFamily="Cormorant Garamond, serif" fontStyle="italic" fontSize="24" fill="#6b7380">Elisier</text>
      </svg>
      <span className="mc-placeholder-label">Imagine în curând{size ? ` · ${size}` : ""}</span>
    </div>
  );
}
